"use client";

import React, { useState } from "react";
import { SectionContentProps } from "../../types";
import LogoUploader from "../../sections/header/LogoUploader";
import { PiListBold, PiXBold } from "react-icons/pi";

export default function AIHeader({
  content,
  onContentChange,
  isSelected,
  defaultLogo,
}: SectionContentProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const fontFamily = content.fontFamily || "'Inter', sans-serif";

  const navItems = content.navItems || ["Features", "About", "Pricing", "Contact"];

  const handleLogoChange = (newLogoUrl: string) => {
    onContentChange?.({ ...content, logo: newLogoUrl });
  };

  return (
    <header
      className={`w-full transition-all relative z-50 bg-black border-b border-purple-950/40 ${isSelected ? "ring-2 ring-blue-500 z-50" : ""}`}
      style={{ fontFamily }}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between py-4">
        <div className="flex items-center flex-shrink-0">
          <LogoUploader
            currentLogo={content.logo}
            defaultLogo={defaultLogo || "AI STARTUP"}
            onLogoChange={handleLogoChange}
            heightClass="h-8"
            primaryColor="#A855F7"
            secondaryColor="#D8B4FE"
            companyName={content.companyName || "AI STARTUP"}
            isEditing={!!onContentChange}
          />
        </div>

        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item: string, idx: number) => (
            <a
              key={idx}
              href={`#${item.toLowerCase()}`}
              className="text-sm font-semibold text-purple-200/70 hover:text-white transition-colors"
            >
              {item}
            </a>
          ))}
        </nav>

        <div className="hidden md:block">
          <a
            href={content.ctaLink || "#apply"}
            className="px-5 py-2 rounded-full bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white font-bold text-sm transition-all shadow-lg shadow-purple-500/25"
          >
            {content.ctaText || "Get Started"}
          </a>
        </div>

        <div className="md:hidden">
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="text-purple-200 hover:text-white p-2"
          >
            {isMobileMenuOpen ? <PiXBold className="h-6 w-6" /> : <PiListBold className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-black border-t border-purple-950/40 py-4 px-6 space-y-4">
          {navItems.map((item: string, idx: number) => (
            <a
              key={idx}
              href={`#${item.toLowerCase()}`}
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-sm font-semibold text-purple-200/70 hover:text-white py-1"
            >
              {item}
            </a>
          ))}
          <a
            href={content.ctaLink || "#apply"}
            onClick={() => setIsMobileMenuOpen(false)}
            className="block text-center py-2.5 rounded-full bg-gradient-to-r from-purple-600 to-indigo-600 text-white font-bold text-sm"
          >
            {content.ctaText || "Get Started"}
          </a>
        </div>
      )}
    </header>
  );
}
